import styled, { css } from 'styled-components'

const alertStyles = {
  info: css`
    background-color: var(--pet-anjo-light-blue);
  `,
  success: css`
    background-color: var(--success-pastel);
  `,
  warning: css`
    background-color: var(--clean-gray);
  `,
  danger: css`
    background-color: var(--light-pink);
  `,
  campaign: css`
    background-color: var(--success-pastel);
  `
}

export const AlertContainer = styled.div`
  align-items: center;
  padding: 16px;
  display: flex;
  border-radius: 16px;
  gap: 16px;
  width: 100%;
  margin: ${props => props.margin ? props.margin : '8px 0 0 0'};
  font-size: 12px;
  text-align: left;
  ${({ type }) => (
  alertStyles[type]
)}
`

export const Message = styled.span`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 145%;
  color: var(--gray-5);
  flex: 1;

  strong {
    font-family: var(--primary-font);
    font-weight: 600;
  }
`
export const Icon = styled.img`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`
export const Title = styled.h1`
  font-family: var(--primary-font);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`
